export enum BrowserType {
  instagram = 'Instagram',
  chrome = 'Chrome',
  safari = 'Safari',
  internetExplorer = 'Internet Explorer',
  firefox = 'Firefox',
  edge = 'Edge',
  opera = 'Opera',
  other = 'Unknown Browser'
}

export const detectBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  switch (true) {
    case userAgent.includes('instagram'):
      return BrowserType.instagram;
    case userAgent.includes('opera') || userAgent.includes('opr'):
      return BrowserType.opera;
    case userAgent.includes('chrome') && !userAgent.includes('edg'):
      return BrowserType.chrome;
    case userAgent.includes('safari') && !userAgent.includes('chrome'):
      return BrowserType.safari;
    case userAgent.includes('firefox'):
      return BrowserType.firefox;
    case userAgent.includes('msie') || userAgent.includes('trident'):
      return BrowserType.internetExplorer;
    case userAgent.includes('edg'):
      return BrowserType.edge;
    default:
      return BrowserType.other;
  }
};
